var React = require('react');

function Social (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"11","cy":"11","r":"6","stroke":"currentColor","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M21 17C24.3137 17 27 14.3137 27 11C27 7.68629 24.3137 5 21 5","stroke":"currentColor","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M3 28V25C3 18.1429 8 17 11 17C14 17 19 18.1429 19 25V28","stroke":"currentColor","strokeWidth":"2","key":2}),React.createElement("path",{"d":"M21 17C24 17 29 18.1429 29 25V28","stroke":"currentColor","strokeWidth":"2","key":3})]);
}

Social.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Social;

Social.default = Social;
